import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

/**
 * Mutation for exchanging token
 *
 * Please keep this variable name in sync with condition in apolloHelper -> errorLink
 */
export const ExchangeTokenMutation: TypedDocumentNode<ExchangeTokenResponse> = gql`
  mutation exchangeToken {
    exchangeToken {
      token
    }
  }
`;

export interface ExchangeTokenResponse {
  exchangeToken: {
    token: string;
  };
}
